globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.Notifications = (function() {

  function Notifications() {
    this.init();
  }

  Notifications.prototype = {
    init: function() {
      this.$body            = $("body");

      if($(window).width() > 769) {
        this.$container = $("#desktop-notifications-container .main-navigation-dropdown-inner");
      } else {
        this.$container = $("#mobile-notifications-container .mobile-header-dropdown-inner");
      }

      this.$counter = $(".badge.badge-notifications");

      appCustomerSpace.LimitlessPlugins.Radio.init(this.$container);

      this.searchFiltersBlur();
      this.getNotifications();
      this.markAllAsViewed();
    },
    notificationsBody: function(){
      return this.$container.find(".dropdown-content-body");
    },
    getNotifications: function() {
      var controller = this;

      controller.$container.on("click", "button.btn-get-notifications", function(e){
        controller.$container.find("input#page").val($(this).val());
        var $searchContainer   = controller.$container.find(".notifications-search-filters");
        var url                = controller.$container.find("form").attr("action");
        var formData           = controller.$container.find("form").serialize();

        e.preventDefault();

        $searchContainer.removeClass().addClass("collapse");
        controller.notificationsBody().empty().removeClass("blured");

        appCustomerSpace.Loader().start({ $container: controller.notificationsBody() });

        $.ajax({
          url: url,
          method: "GET",
          data: formData,
          success: function(data) {
            if(data.notifications_view.length > 0) {
              appCustomerSpace.Loader().stop({ $container: controller.notificationsBody() }, function(){
                controller.$container.html(data.notifications_view);
                appCustomerSpace.LimitlessPlugins.Radio.init(this.$container);
                controller.refreshCounter(data.notifications_count);
                //controller.init();
                // Demander à Paul pourquoi il a fait ça ?!
                // Chaque fois que le controller s'init, il rebind les events de la pagination
                // Ce qui décuple les appels bdd à chaque click (1, 2, 4, 8, 16, ...)
              });
            }
          },
          error: function() {
            bootbox.alert({
              message: "Une erreur est survenue lors du chargements des notifications.",
              callback: function(){
                this.hide();
              }
            })
          }
        });

      })
    },
    markAllAsViewed: function() {
      var controller = this;

      controller.$container.on("click", ".mark-all-notifications-as-viewed", function(){
        var url = $(this).data("ajax-url");

        var modalOptions = {
          message: "Voulez-vous marquer toutes vos notifications comme vues ?",
          buttons: {
            confirm: {
              label: "Confirmer",
              className: "btn btn-primary float-right mr-10",
            },
            cancel: {
              label: "Annuler",
              className: "btn btn-default float-right",
            }
          },
          callback: function(result) {
            if(result) {
              controller.notificationsBody().empty();
              appCustomerSpace.Loader().start({ $container: controller.$container });

              $.ajax({
                url: url,
                method: "POST",
                success: function(data) {
                  if(data.response == 1 && data.notifications_view.length > 0) {
                    appCustomerSpace.Loader().stop({ $container: controller.$container }, function(){
                      controller.$container.empty().append(data.notifications_view);
                      controller.refreshCounter(data.notifications_count);
                    });
                  } else if (data.reponse == 0) {
                    bootbox.alert({
                      message: "Impossible de marquer vos notifications comme vues",
                      callback: function(){
                        this.hide();
                      }
                    })
                  }
                },
                error: function() {
                  bootbox.alert({
                    message: "Impossible de marquer vos notifications comme vues",
                    callback: function(){
                      this.hide();
                    }
                  })
                }
              });
            }
            this.hide();
            if($(window).width() > 769) {
              controller.$container = $("#desktop-notifications-container .main-navigation-dropdown-inner");
            }
          }
        }

        bootbox.confirm(modalOptions);
      })
    },
    searchFiltersBlur: function() {
      var controller = this;
      var $searchBtn   = controller.$container.find(".search-filters-btn");

      $searchBtn.on("click", function() {
        controller.notificationsBody().toggleClass("blured")
      })
    },
    refreshCounter: function(count) {
      var controller = this;
      if(count && count > 0) {
        total = count > 99 ? "99+" : count
        controller.$counter.html(total);
      } else {
        controller.$counter.hide();
      }
    }
  }

  return Notifications;
})();
